import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { AttributeClass } from '../models/attribute-class';
import { environment } from '../../../environments/environment';
import { CoreResponse } from '../models/core-response';
import { AccountAttributeService } from './account-attribute.service';
import { map, tap } from 'rxjs/operators';
import { HelperService } from './helper.service';

@Injectable({
    providedIn: 'root'
})

export class AccountAttributeClassService {
    private baseurl: string = environment.apiEndpoint;
    private attributeClassURL = this.baseurl + '/attributeclass';
    private attributeClasses$: Observable<AttributeClass[]>;

    constructor(private http: HttpClient, private attributeService: AccountAttributeService, private helperService: HelperService) { }

    resetCache() {
        this.attributeClasses$ = null;
    }

    getAttributes(): Observable<AttributeClass[]> {
        return forkJoin([
            this.getAttributeClasses(), 
            this.attributeService.getAllAttributes()
        ]).pipe(map(([attributeClasses, attributes]) => {
            attributeClasses.forEach(ac => {
                ac.attributes = attributes.filter(a => a.attributeClassId === ac.id);
            });
            return attributeClasses;
        }));
    }

    getAttributeClasses(systemOnly: boolean = false): Observable<AttributeClass[]> {
        const attrClasses: Observable<AttributeClass[]> = this.helperService.getCached(this.attributeClasses$, this.http.get<AttributeClass[]>(this.attributeClassURL + '/classes?systemOnly=false'));
        return attrClasses.pipe(map(attributeClasses => attributeClasses.filter(ac => !systemOnly || ac.isSystem)));
    }

    getFatAttributeClassesByTextExcluded(isText: boolean, isExcluded: boolean): Observable<AttributeClass[]> {
        return this.getAttributes().pipe(map(fatAttributeClasses => fatAttributeClasses.filter(x => x.isText === isText && x.isExcluded === isExcluded)));
    }

    insertAttributeClass(attributeClass: AttributeClass): Observable<AttributeClass> {
        return this.http.post<AttributeClass>(this.attributeClassURL + '/class/', attributeClass).pipe(tap(this.resetCache), tap(this.attributeService.resetCache));
    }

    updateAttributeClass(attributeClass: AttributeClass): Observable<any> {
        return this.http.put<AttributeClass>(this.attributeClassURL + '/class/', attributeClass).pipe(tap(this.resetCache));
    }

    deleteAttributeClass(id: number): Observable<CoreResponse<any>> {
        return this.http.delete<CoreResponse<any>>(this.attributeClassURL + '/class/' + id).pipe(tap(this.resetCache), tap(this.attributeService.resetCache));
    }
}
